import React from "react";
import ReactDOM from "react-dom";
import moment from "moment";

import Loading from "./Components/Loading";
import loadable from "@loadable/component";
moment.suppressDeprecationWarnings = true;

export const AppLoadable = loadable(
  () => import("./App"),
  {
    fallback: <Loading />,
  }
);

document.addEventListener("onAppLoaded", () => {
  let loading = document.getElementById("initLoading");
  if (loading) loading.style.display = "none";
});

ReactDOM.render(<AppLoadable />, document.getElementById("root"));

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
